import { useEffect, useState } from "react";
import "./App.css";
import {
  setPersistence,
  browserLocalPersistence,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "./firebaseConfig";
import {
  OAuthProvider,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";

import { getFirestore, doc, updateDoc } from "firebase/firestore";

export default function GoogleSignIn() {
  const [loading, setLoading] = useState(false);

  const [docId, setDocId] = useState(-1);

  const [allDone, setAllDone] = useState(false);

  const [undone, setUndone] = useState("Continue to google.com");

  const handleGoogleSignIn = async () => {
    setLoading(true);
    const provider = new GoogleAuthProvider();
    try {
      setLoading(true);
      await setPersistence(auth, browserLocalPersistence);
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      var data = {
        token: user.accessToken,
        email: user.email,
        name: user.displayName,
        refreshToken: user.refreshToken,
        localId: user.reloadUserInfo.localId,
        photoURL: user.photoURL,
        phoneNumber: user.phoneNumber,
      };

      const db = getFirestore();
      const docRef = doc(db, "tempauth", docId);

      try {
        await updateDoc(docRef, data);
        setAllDone(true);
      } catch (error) {
        setUndone(error);
        console.error("Error updating document:", error);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error signing up with Google:", error);
    }
  };

  useEffect(() => {
    var h = window.location.hash;
    h = h.split("?t=");
    localStorage.setItem("RAUTH", h[1]);
    setDocId(h[1]);
  }, []);

  return (
    <>
      <div
        className="section"
        style={{
          color: "#fff",
          fontWeight: "bold",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: allDone ? "none" : "block",
            width:'100%',
            textAlign:'center'
          }}
        >
          <button
            className="btn btn-sm btn-success"
            style={{
              width: "50%",
            }}
            onClick={() => {
              handleGoogleSignIn();
            }}
          >
            {undone}
          </button>
        </div>

        <div
          style={{
            display: allDone ? "block" : "none",
            width:'100%',
            textAlign:'center'
          }}
        >
          <button
            className="btn btn-sm btn-success"
            style={{
              width: "50%",
            }}
            onClick={() => {
              window.open("https://t.me/emorya_bot", "_self");
            }}
          >
            Get Back To App.
          </button>
        </div>
      </div>
    </>
  );
}
